module.exports = __webpack_public_path__ + "img/no-sensor-heading.78f8d832.svg";